/* eslint-disable import/prefer-default-export */
export const APP_VERSION = process.env.REACT_APP_VERSION;
export const APP_ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
export const SENTRY_AUTH_TOKEN = process.env.REACT_APP_SENTRY_AUTH_TOKEN;
export const SENTRY_ORG = 'scalar-app';
export const SENTRY_PROJECT = 'frontend';
export const SENTRY_ENVIRONMENTS = ['production', 'staging'];

export const DECIMAL_PLACES = 15;
export const ONE_HUNDRED_VALUE = 100;
export const MAX_HISTORICAL_YEARS = 3;
